import React from "react";
import removeImg from "assets/svgs/close.svg";
import { v4 } from "uuid";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ImageUpdateEn from "./ImageUpdateEn";
import ImageUpdateAr from "./ImageUpdateAr";
import { useForm } from "react-hook-form";
import { Input, Textarea } from "components/shared/FormComponents";

const SlidersArray = ({ sliders, setSliders, register, errors }) => {
  const { handleSubmit, reset } = useForm();


  const removeSlider = (sliderId) => {
    const newSliders = sliders?.filter(
      (slider, index) => slider.id !== sliderId
    );
    setSliders(() => newSliders);
  };

  const addSlider = () => {
    setSliders(() => [...(sliders || []), { id: v4(), imageAr: "", imageEn: "", heading: { ar: "", en: "" }, description: { ar: "", en: "" }, 
    // buttonText: { ar: "", en: "" } 
  }]);
  };


  return (
    <div className="form-group branches sliders">
      <Row style={{ rowGap: "10px" }}>
        <h5>
          <FormattedMessage id={"intro"} />
        </h5>

        {sliders?.map((slider, index) => {
          return (
            <Col xl={12} xs={12} key={slider.id} className="">
              <div className="add-multi-component">
                <Row>
                  <button
                    type="button"
                    onClick={() => removeSlider(slider.id)}
                    className="removeImg"
                  >
                    <img src={removeImg} alt="" />
                  </button>
                  {/* name */}
                  <Col lg={6} className="text-center">
                    <ImageUpdateAr
                      title="imageAr"
                      index={index}
                      item={slider}
                      sliders={sliders}
                      setSliders={setSliders}
                    />
                  </Col>
                  <Col lg={6} className="text-center">
                    <ImageUpdateEn
                      title="imageEn"
                      index={index}
                      item={slider}
                      sliders={sliders}
                      setSliders={setSliders}
                    />
                  </Col>

               
                    <Col lg={6} xs={12}>
                      <Input
                        langId="title"
                        name={`${index}.heading.ar`}
                        register={register}  
                        rules={{ required: true }} 
                        errors={errors}
                        value={slider?.heading?.ar || ""}
                        onChange={(e) => {
                          const newSliders = [...sliders];
                          newSliders[index].heading.ar = e.target.value;
                          setSliders(newSliders);
                        }}
                      />
                      {errors[index]?.heading?.ar?.type === "required" && (
                        <p className="text-danger">
                          <FormattedMessage id="headerRequired" />
                        </p>
                      )}
                    </Col>

                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name={`${index}.heading.en`}
                      register={register}
                      errors={errors}
                      rules={{ required: true }} 
                      value={slider?.heading?.en || ""}
                      onChange={(e) => {
                        const newSliders = [...sliders];
                        newSliders[index].heading.en = e.target.value;
                        setSliders(newSliders);
                      }}
                    />
                    {errors[index]?.heading?.en?.type === "required" && (
                      <p className="text-danger">
                        <FormattedMessage id="headerRequired" />
                      </p>
                    )}
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="description"
                      name={`${index}.description.ar`}
                      register={register}
                      errors={errors}
                      rules={{ required: true }} 
                      value={slider?.description?.ar || ""}
                      onChange={(e) => {
                        const newSliders = [...sliders];
                        newSliders[index].description.ar = e.target.value;
                        setSliders(newSliders);
                      }}
                    />
                    {errors[index]?.description?.ar?.type === "required" && (
                      <p className="text-danger">
                        <FormattedMessage id="descriptionRequired" />
                      </p>
                    )}
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="description"
                      name={`${index}.description.en`}
                      register={register}
                      errors={errors}
                      value={slider.description.en || ""}
                      rules={{ required: true }}
                      onChange={(e) => {
                        const newSliders = [...sliders];
                        newSliders[index].description.en = e.target.value;
                        setSliders(newSliders);
                      }}
                    />
                    {errors[index]?.description?.en?.type === "required" && (
                      <p className="text-danger">
                        <FormattedMessage id="descriptionRequired" />
                      </p>
                    )}
                  </Col>
                  {/* <Col lg={6} xs={12}>
                    <Input
                      langId="buttonText"
                      name={`${index}.buttonText.ar`}
                      register={register}
                      errors={errors}
                      value={slider?.buttonText?.ar || ""}
                      onChange={(e) => {
                        const newSliders = [...sliders];
                        newSliders[index].buttonText.ar = e.target.value;
                        setSliders(newSliders);
                      }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="buttonText"
                      name={`${index}.buttonText.en`}
                      register={register}
                      errors={errors}
                      value={slider?.buttonText?.en || ""}
                      onChange={(e) => {
                        const newSliders = [...sliders];
                        newSliders[index].buttonText.en = e.target.value;
                        setSliders(newSliders);
                      }}
                    />
                  </Col> */}

                </Row>
              </div>
            </Col>
          );
        })}

        <Row>
          <Col lg={4} xs={12} className="text-left">
            <button
              type="button"
              className="btn btn-green add_new_section__"
              onClick={() => {
                addSlider();
              }}
            >
              <FormattedMessage id={"addIntro"} />
            </button>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default SlidersArray;
